import { Type } from 'class-transformer';
import { ApiPropertyOptional } from '@nestjs/swagger';

import { SpConnectHeaderInterface } from '../interfaces/sp-connect-header.interface';
import { SpConnectChangeTypeEnum } from '../enums/sp-connect-change-type.enum';
import { SpConnectOrderTypeEnum } from '../enums/sp-connect-order-type.enum';
import { SpConnectPurposeEnum } from '../enums/sp-connect-purpose.enum';
import { SpConnectBuilderDto } from './sp-connect-header-builder.dto';
import { SpConnectJobDto } from './sp-connect-job.dto';
import { SpConnectTaskDto } from './sp-connect-task.dto';

export class SpConnectHeaderDto implements SpConnectHeaderInterface {
  @ApiPropertyOptional({ type: 'string' })
  builderOrderNumber?: string;

  @ApiPropertyOptional({ type: 'string', format: 'date-time' })
  issueDate?: Date;

  @ApiPropertyOptional({ type: 'string', format: 'date-time' })
  startDate?: Date;

  @ApiPropertyOptional({ type: 'string', format: 'date-time' })
  endDate?: Date;

  @ApiPropertyOptional({ type: 'enum', enum: SpConnectPurposeEnum })
  purpose?: SpConnectPurposeEnum;

  @ApiPropertyOptional({ type: 'enum', enum: SpConnectOrderTypeEnum })
  orderType?: SpConnectOrderTypeEnum;

  @ApiPropertyOptional({ type: 'enum', enum: SpConnectChangeTypeEnum })
  changeType?: SpConnectChangeTypeEnum;

  @ApiPropertyOptional({ type: 'string', format: 'date-time' })
  changeOrderIssueDate?: Date;

  @ApiPropertyOptional({ type: 'string' })
  changeOrderNumber?: string;

  @ApiPropertyOptional({ type: 'number' })
  changeOrderSequence?: number;

  @ApiPropertyOptional()
  @Type(() => SpConnectBuilderDto)
  builder?: SpConnectBuilderDto;

  @ApiPropertyOptional()
  @Type(() => SpConnectJobDto)
  job?: SpConnectJobDto;

  @ApiPropertyOptional()
  @Type(() => SpConnectTaskDto)
  task?: SpConnectTaskDto;
}
